import React, { useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import {
  Scissors,
  CalendarDays,
  Tag,
  BookOpen,
  TrendingUp,
} from "lucide-react";
import "../../../assets/css/admin/dashboardcss/AdminDashboard.css";
import AdminLayout from "../../../layouts/admin/AdminLayout";
import { checkLoggedInAdmin } from "../../../helper/CustomHelper";
import { useNavigate } from "react-router-dom";

/* ── Static data ── */
const SGC_STATS = [
  {
    id: "treatments",
    icon: Scissors,
    value: 7,
    label: "Total treatments",
    trend: "+2",
  },
  {
    id: "appointments",
    icon: CalendarDays,
    value: 47,
    label: "Appointments (this week)",
    trend: "+12",
  },
  {
    id: "deals",
    icon: Tag,
    value: 4,
    label: "Active deals",
    trend: "+1",
  },
  {
    id: "blogs",
    icon: BookOpen,
    value: 3,
    label: "Blog posts",
    trend: "+1",
  },
];

const SGC_ACTIVITY = [
  { id: 1, name: "Aisha R.",  initials: "A", action: "booked Hydrafacial",            time: "2m ago"  },
  { id: 2, name: "Hira K.",   initials: "H", action: "rebooked Acne Treatment",        time: "18m ago" },
  { id: 3, name: "Mariam S.", initials: "M", action: "claimed Laser Hair Removal Bundle", time: "1h ago"  },
  { id: 4, name: "Sara W.",   initials: "S", action: "left a 5-star review",           time: "3h ago"  },
  { id: 5, name: "Noor F.",   initials: "N", action: "booked Chemical Peel",           time: "5h ago"  },
];

const AdminDashboard = () => {
  const navigate = useNavigate();
  useEffect(()=>{
      checkLoggedInAdmin(navigate);
  },[]);

  return (
    <AdminLayout>
    <div className="sgc-dash">

      {/* ── Header ── */}
      <div className="sgc-dash__header">
        <h2 className="sgc-dash__welcome">Welcome back</h2>
        <p className="sgc-dash__subtitle">
          Here's what's happening today at Estetica Skin&amp;Laser.
        </p>
      </div>

      {/* ── Stat Cards ── */}
      <Row className="sgc-dash__stats g-3 mb-4">
        {SGC_STATS.map(({ id, icon: Icon, value, label, trend }) => (
          <Col key={id} xs={12} sm={6} xl={3}>
            <div className="sgc-dash__stat-card">
              <div className="sgc-dash__stat-top">
                <div className="sgc-dash__stat-icon-wrap">
                  <Icon className="sgc-dash__stat-icon" size={20} />
                </div>
                <span className="sgc-dash__stat-trend">
                  <TrendingUp size={13} />
                  {trend}
                </span>
              </div>
              <p className="sgc-dash__stat-value">{value}</p>
              <p className="sgc-dash__stat-label">{label}</p>
            </div>
          </Col>
        ))}
      </Row>

      {/* ── Recent Activity ── */}
      <Row>
        <Col xs={12}>
          <div className="sgc-dash__activity-card">
            <h3 className="sgc-dash__activity-title">Recent activity</h3>

            <ul className="sgc-dash__activity-list">
              {SGC_ACTIVITY.map(({ id, name, initials, action, time }) => (
                <li key={id} className="sgc-dash__activity-item">
                  <div className="sgc-dash__activity-left">
                    <div className="sgc-dash__activity-avatar">
                      {initials}
                    </div>
                    <div className="sgc-dash__activity-info">
                      <p className="sgc-dash__activity-name">{name}</p>
                      <p className="sgc-dash__activity-action">{action}</p>
                    </div>
                  </div>
                  <span className="sgc-dash__activity-time">{time}</span>
                </li>
              ))}
            </ul>

          </div>
        </Col>
      </Row>

    </div>
    </AdminLayout>
  );
};

export default AdminDashboard;